import { render, staticRenderFns } from "./CollectDetail.vue?vue&type=template&id=4379bbf6&scoped=true&"
import script from "./CollectDetail.vue?vue&type=script&lang=js&"
export * from "./CollectDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379bbf6",
  null
  
)

export default component.exports